import SelectField from '@pelckmans/elementis/components/select-field';
import { ComponentProps } from 'react';

interface Module {
  id: string;
  niceName: string;
  catalogName?: string;
  isVirtualExerciseModule?: boolean;
}

type UnwrapArray<T> = T extends (infer U)[] ? U : T;

interface Props<T> extends Pick<ComponentProps<typeof SelectField>, 'size' | 'readOnly' | 'className'> {
  modules: T[];
  selectedModule: UnwrapArray<T> | null;
  setSelectedModule: (module: T) => void;
  ariaLabel: string;
  dropdownMenuAriaLabel?: string;
  useCatalogName?: boolean;
}

export default function ModuleSelectionField<T extends Module>({
  modules,
  selectedModule,
  setSelectedModule,
  ariaLabel,
  dropdownMenuAriaLabel,
  useCatalogName,
  className,
  size = 'sm',
  readOnly,
}: Props<T>) {
  if (modules.length === 0) return null;

  return (
    <SelectField
      value={selectedModule}
      onChange={setSelectedModule}
      renderValueContent={module => (useCatalogName ? module.catalogName || module.niceName : module.niceName)}
      required
      size={size}
      aria-label={ariaLabel}
      dropdownMenuProps={{ ariaLabel: dropdownMenuAriaLabel }}
      className={className}
      readOnly={readOnly}
    >
      {modules.map(module => (
        <SelectField.Item
          value={module}
          text={useCatalogName ? module.catalogName || module.niceName : module.niceName}
          key={`${module.id}-${module.isVirtualExerciseModule}`}
        />
      ))}
    </SelectField>
  );
}
